import { useQuery } from "react-query";
import { fetchAPIUserOrdersPending } from "../requests/UserOrders";

export function useQueryUserOrdersPending(user_id: number) {
  const onError = () => {};
  return useQuery(
    "apiUserOrdersPending",
    async () => await fetchAPIUserOrdersPending(user_id),
    {
      onError,
      refetchInterval: 1000 * 25
    }
  );
}